import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import AppsList from './components/AppsList';
import PurchaseHistory from './components/PurchaseHistory';
import TopUpSelector from './components/TopUpSelector';
import SuccessModal from './components/SuccessDialog';
import { StyledContainer, StyledRow } from './styled';
import { SUCCESS_SEARCH_PARAM } from '../../constants';
import userApi from '../../api/userApi';
import HeadMetaData from '../HeadMetaData';
import { meta } from '../../metaInfo';

const UserApps = () => {
  const { data } = userApi.useGetUserAppsQuery();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const deleteSuccessSearchParam = useCallback(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(SUCCESS_SEARCH_PARAM);
    setSearchParams(newParams, { replace: true });
  }, [setSearchParams]);

  useEffect(() => {
    if (searchParams.has(SUCCESS_SEARCH_PARAM)) {
      setIsSuccessModalOpen(true);
      deleteSuccessSearchParam();
      return;
    }
  }, [searchParams, deleteSuccessSearchParam]);

  return (
    <>
      <HeadMetaData
        title={meta.myApps.title}
        description={meta.myApps.description}
      />
      <StyledContainer>
        <AppsList />
        {data && data?.length > 0 && (
          <StyledRow>
            <TopUpSelector />
            <PurchaseHistory />
          </StyledRow>
        )}
      </StyledContainer>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        onClose={() => setIsSuccessModalOpen(false)}
      />
    </>
  );
};

export default UserApps;
